import { render, staticRenderFns } from "./AddressPop.vue?vue&type=template&id=4dd68263&scoped=true&"
import script from "./AddressPop.vue?vue&type=script&lang=js&"
export * from "./AddressPop.vue?vue&type=script&lang=js&"
import style0 from "./AddressPop.vue?vue&type=style&index=0&id=4dd68263&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd68263",
  null
  
)

export default component.exports